module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/filter"
// module id = 23
// module chunks = 0